import { render } from "./svgButton.vue?vue&type=template&id=163aaf45"
import script from "./svgButton.vue?vue&type=script&lang=js"
export * from "./svgButton.vue?vue&type=script&lang=js"

import "./svgButton.vue?vue&type=style&index=0&id=163aaf45&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__